import client from "./client";
import type { LoginResponse, RegistrationInfo } from "@/types";

export async function validateRegistrationToken(token: string): Promise<RegistrationInfo> {
  const { data } = await client.get<RegistrationInfo>("/v1/auth/registration", {
    params: { token },
  });
  return data;
}

export async function register(params: {
  token: string;
  password: string;
}): Promise<LoginResponse> {
  const { data } = await client.post<LoginResponse>("/v1/auth/register", params);
  return data;
}

export async function login(email: string, password: string): Promise<LoginResponse> {
  const { data } = await client.post<LoginResponse>("/v1/auth/login", { email, password });
  return data;
}

export async function logout(refreshToken: string): Promise<void> {
  await client.delete("/v1/auth/logout", { data: { refresh_token: refreshToken } });
}

export async function forgotPassword(email: string): Promise<void> {
  await client.post("/v1/auth/forgot-password", { email });
}

export async function resetPassword(token: string, password: string): Promise<void> {
  await client.post("/v1/auth/reset-password", { token, password });
}
